import { render, staticRenderFns } from "./product-detail-loader.vue?vue&type=template&id=55e03924&scoped=true"
import script from "./product-detail-loader.vue?vue&type=script&lang=js"
export * from "./product-detail-loader.vue?vue&type=script&lang=js"
import style0 from "./product-detail-loader.vue?vue&type=style&index=0&id=55e03924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e03924",
  null
  
)

export default component.exports